// extracted by mini-css-extract-plugin
export default {"root":"InfoPanel_root__itG3c","content":"InfoPanel_content__mSDyj"};